import {
    RUN_REPLACEMENT_FAILURE,
    RUN_REPLACEMENT_REQUEST,
    RUN_REPLACEMENT_SUCCESS,
} from "actions/replacement";

const initialState = {
    loading: false,
    error: {},
    replacement: {}
};

export default function replacement(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RUN_REPLACEMENT_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }

        case RUN_REPLACEMENT_SUCCESS: {
            return {
                ...state,
                loading: false,
                replacement: payload,
            };
        }

        case RUN_REPLACEMENT_FAILURE: {
            return {
                ...state,
                loading: false,
                replacement: {},
            };
        }

        default:
            return state;
    }
}
